import { FirstStepsModal } from '../../../presentation/components'

const FirstStepsModalFactory = () => {
  const handeClick = () => {
    window.location.pathname = '/meus-dados'
  }

  return (
    <FirstStepsModal
      title={'Vamos começar atualizando seus dados'}
      buttonInnerText={'Vamos lá'}
      handleClick={() => handeClick()}
    />
  )
}

export default FirstStepsModalFactory
